import { useCallback } from "react";

// TODO(ben-admin-renewal): Move this export to the Features folder
import { medicalPlansApi } from "EmployerApplication/api";
import { MedicalPlanPrice } from "Utils/types";

import useAsync from "Common/useAsync";

export const useGetMedicalPlans = <T = MedicalPlanPrice[]>(ids: string[], zipcode: string, company_id_token: string | null | undefined) => {
  const asyncFunction = useCallback(
    () => medicalPlansApi(ids, zipcode, company_id_token).then((response) => response.json()),
    [ids, zipcode, company_id_token],
  );
  const { data, error, isLoading } = useAsync(asyncFunction);
  const plans = data?.plans as T;
  return { plans, error, isLoading };
};
